(function () {
  function syncToggleState(hasSublist, expanded) {
    var toggle = hasSublist && hasSublist.querySelector('.mobile-nav__toggle');
    if (!toggle) return;
    toggle.classList.toggle('mobile-nav--expanded', expanded);
  }

  function collapseAll(drawer, except) {
    drawer.querySelectorAll('.mobile-nav--main .mobile-nav__has-sublist.mobile-nav--expanded').forEach(function (el) {
      if (el === except) return;
      el.classList.remove('mobile-nav--expanded');
      syncToggleState(el, false);
    });
  }

  function toggleHasSublist(drawer, hasSublist) {
    if (!hasSublist) return;
    var willExpand = !hasSublist.classList.contains('mobile-nav--expanded');
    collapseAll(drawer, willExpand ? hasSublist : null);
    if (willExpand) {
      hasSublist.classList.add('mobile-nav--expanded');
      syncToggleState(hasSublist, true);
    } else {
      hasSublist.classList.remove('mobile-nav--expanded');
      syncToggleState(hasSublist, false);
    }
  }

  function bindMobileNavDrawer() {
    var drawer = document.getElementById('NavDrawer');
    if (!drawer || drawer.dataset.artbeatNavBound === 'true') return;
    drawer.dataset.artbeatNavBound = 'true';

    drawer.addEventListener(
      'click',
      function (evt) {
        var toggleBtn = evt.target.closest('.mobile-nav--main .mobile-nav__toggle button');
        if (toggleBtn) {
          evt.preventDefault();
          evt.stopPropagation();
          toggleHasSublist(drawer, toggleBtn.closest('.mobile-nav__has-sublist'));
          return;
        }

        var link = evt.target.closest('.mobile-nav--main .mobile-nav__has-sublist > a.mobile-nav__link');
        if (link) {
          evt.preventDefault();
          evt.stopPropagation();
          toggleHasSublist(drawer, link.closest('.mobile-nav__has-sublist'));
          return;
        }

        var row = evt.target.closest('.mobile-nav--main .mobile-nav__has-sublist');
        if (row && !evt.target.closest('a') && !evt.target.closest('button')) {
          toggleHasSublist(drawer, row);
        }
      },
      true
    );
  }

  function init() {
    bindMobileNavDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    var drawer = document.getElementById('NavDrawer');
    if (drawer) delete drawer.dataset.artbeatNavBound;
    bindMobileNavDrawer();
  });
})();
